<template>
  <v-dialog v-model="show" width="400">
    <v-card>
      <v-card-title><h2>Confirm Deletion</h2>
        <v-spacer />
        <v-btn icon  @click="show = false">
            <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>{{ title }}</v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="primary" text @click="destroy">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

const DEFAULT_TITLE = "Are you sure you want to delete this item?";
const DEFAULT_CALLBACK = () => {};

export default {
  name: "delete-modal",
  data() {
    return {
      show: false,
      title: DEFAULT_TITLE,
      callback: DEFAULT_CALLBACK
    };
  },
  watch: {
    show(val) {
      if (!val) this.close();
    }
  },
  methods: {
    destroy() {
      this.callback();
      this.show = false;
    },
    open(packet = {}) {
      this.title = packet.title || DEFAULT_TITLE;
      this.callback = packet.callback || DEFAULT_CALLBACK;

      this.show = true;
    },
    close() {
      this.title = DEFAULT_TITLE;
      this.callback = DEFAULT_CALLBACK;
    }
  },
  beforeDestroy() {
    const vm = this;

    vm.$root.eventHub.$off("open-delete-modal", vm.open);
    vm.$root.eventHub.$off("close-delete-modal", vm.close);
  },
  mounted() {
    const vm = this;

    vm.$root.eventHub.$on("open-delete-modal", vm.open);
    vm.$root.eventHub.$on("close-delete-modal", vm.close);
  }
};
</script>

<style>
</style>